// CRITICAL DEBUG - fires first
console.log('==========================================');
console.log('[MAIN.JS] Application starting...');
console.log('==========================================');

import { createApp } from 'vue';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'billboard.js/dist/billboard.css';
import './assets/styles/main.scss';
import App from './App.vue';
import router from './router';
import { initAnalytics } from './composables/useAnalytics.js';

console.log('[MAIN.JS] Imports loaded successfully');

// Global error handler
window.addEventListener('error', (event) => {
  console.error('==========================================');
  console.error('[GLOBAL ERROR HANDLER]', event.error);
  console.error('[GLOBAL ERROR HANDLER] Message:', event.message);
  console.error('[GLOBAL ERROR HANDLER] Filename:', event.filename);
  console.error('[GLOBAL ERROR HANDLER] Line:', event.lineno);
  console.error('==========================================');
});

window.addEventListener('unhandledrejection', (event) => {
  console.error('==========================================');
  console.error('[UNHANDLED PROMISE REJECTION]', event.reason);
  console.error('==========================================');
});

// Initialize Google Analytics 4
// Use VITE_GA4_MEASUREMENT_ID environment variable or fallback to test ID
const measurementId = import.meta.env.VITE_GA4_MEASUREMENT_ID || 'G-XXXXXXXXXX';
console.log('[MAIN.JS] Initializing analytics with ID:', measurementId);
initAnalytics(measurementId);

console.log('[MAIN.JS] Creating Vue app');
const app = createApp(App);

// Add Vue Router (must be before mount)
console.log('[MAIN.JS] Adding router to app');
app.use(router);

// Add global error handler
app.config.errorHandler = (err, instance, info) => {
  console.error('==========================================');
  console.error('[VUE ERROR HANDLER]', err);
  console.error('[VUE ERROR HANDLER] Info:', info);
  console.error('[VUE ERROR HANDLER] Component:', instance);
  console.error('==========================================');
};

console.log('[MAIN.JS] Mounting app to #app');
app.mount('#app');
console.log('[MAIN.JS] App mounted successfully');
console.log('==========================================');
